import React, { Component} from 'react';
import { connect } from 'react-redux';
import Intro from 'components/Quiz/Intro';
import Question from 'components/Quiz/Question';
import Results from 'components/Quiz/Results';
import actions from 'actions';
const {
  hideModal,
  checkAnswersSaga
} = actions;

class Quiz extends Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
    let answers = {};
    let questions = this.generateQuiz(this.props.webinar.spd_quizzes);
    questions.forEach(question => {
      answers[question.id.toString()] = null
    })
    this.state = {
      answers,
      questions,
    }
  }

  quiz = () => {
    const {
      webinar
    } = this.props;
    let question = <Intro onClick={this.nextQuestion} />;
    const newQuiz = this.state.questions.find(quiz => quiz.id == this.state.question);
    if (newQuiz)
      question = <Question
                   onClick={this.nextQuestion}
                   question={newQuiz}
                   questions={this.state.questions}
                   changeAnswerValue={this.changeAnswerValue}
                   answers={this.state.answers}
                 />;
     if (this.state.question == -1) {
       this.props.checkAnswers(this.state.answers, this.props.webinar.id)
       question = <Results onClick={this.props.hideModal}
                    failed={this.props.quizStatus == `failed_${this.props.webinar.id}`}
                    completed={this.props.quizStatus == `completed_${this.props.webinar.id}`}
                    quizResult={this.props.quizResult}
                    webinar={webinar}
                  />;
     }
    return question;
  }

  changeAnswerValue = (id, value) => {
    this.setState({
      answers: { ...this.state.answers,
        ...{
          [id.toString()]: value
        }
      }
    })
  }

  generateQuiz = (questions) => {
    if (questions.length <= 10)
      return questions;
    let questionsSelect = questions.slice();
    let newQuestions = [];
    while(newQuestions.length <= 10) {
      const element = questionsSelect.splice(Math.floor(Math.random(questionsSelect.length) * 10), 1)[0];
      if (element) newQuestions.push(element)
      if (!questionsSelect.length || newQuestions.length >= 10)
        break;
    }
    return newQuestions;
  }

  nextQuestion = () => {
    const {
      webinar
    } = this.props;
    const ids = this.state.questions.map(e => e.id);

    let newQuizId = this.state.question;

    const questionIndex = ids.indexOf(newQuizId);

    if (!newQuizId)
      newQuizId = (this.state.questions[0] || {}).id
    newQuizId = ((this.state.questions[questionIndex + 1] || {}).id || -1)

    this.setState({
      question: newQuizId
    });
  }

  render() {
    return (
      <this.quiz />
    );
  }
}

const mapStateToProps = (state) => ({
  quizStatus: state.quiz.status,
  quizResult: state.quiz.result
});
const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(hideModal()),
  checkAnswers: (answers, webinarId) => dispatch(checkAnswersSaga(answers, webinarId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);



/** WEBPACK FOOTER **
 ** ./src/containers/Quiz/Quiz.jsx
 **/